import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import 'select2';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../../utils/capitalize";
import 'react-quill/dist/quill.snow.css';
import {useDispatch, useSelector} from "react-redux";
import {getMembershipReport, sync, user} from "../../../api/app";
import formatNumber from "../../../utils/formatNumber.js";
import generateChar from "../../../utils/generateChar";

let filter = {};

const searchableFields = [
    { field: 'name', isNumeric: false },
    { field: 'mobile_number', isNumeric: true },
    { field: 'id_number', isNumeric: false },
    { field: 'user.location.provincial.name', isNumeric: false }
];

const qualification = ["General", "Grade 9", "Grade 12", "Certificate", "Diploma", "Degree", "Masters", "PhD"];

const Membership = () => {

    document.title = "Membership";

    const token = localStorage.getItem('jwtToken');
    const dispatch = useDispatch();
    const {province, districts, constituencies, wards} = useSelector(state => state.app?.administrative);

    const [stateReady, setStateReady] = useState(false);
    const [provincialSelected, setProvincialSelected] = useState(null);
    const [districtSelected, setDistrictSelected] = useState(null);
    const [constituencySelected, setConstituencySelected] = useState(null);
    const [reset, setReset] = useState(new Date().getTime());
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);

    useEffect(() => {
        getMembershipReport().then((response) => {
            if(!response.error) {
                $('#total-users').text(formatNumber(response.payload.total, "digit"));
                $('#date-current').text(response.payload.date_current);
                $('#month-current').text(response.payload.month_current);
                $('#daily-active').text(formatNumber(response.payload.daily, "digit"));
                $('#monthly-active').text(formatNumber(response.payload.monthly, "digit"));
                $('#total-gender').text(`Male: ${formatNumber(response.payload.total_male, "digit")} --- Female: ${formatNumber(response.payload.total_female, "digit")}`);
            }
        });
    }, [reset]);

    useEffect(() => {
        dispatch(sync());
    }, []);

    useEffect(() => {
        let table = $('#user').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Membership Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "user",
                        searchableFields,
                        filter,
                        pageSize: data.start,
                        format: 'json',
                        sort: { _id: -1 },
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return capitalize(data.name);
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data?.mobile_number;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return capitalize(data.gender);
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return {
                            "pending" : `<div class="d-flex align-items-center"><span class="badge badge-secondary tx-white">Pending</span> ${data?.meta?.status ? `<i class="tx-danger fa fa-times-circle ml-1"></i>` : ''}</div>`,
                            "awaiting" : `<span class="badge badge-primary tx-white">Awaiting</span>`,
                            "approved" : `<span class="badge badge-success tx-white">Approved</span>`,
                            "rejected" : `<span class="badge badge-danger tx-white">Rejection</span>`
                        }[data.status];
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.date.iso).format("Do MMM, YYYY HH:mm");
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href='#/membership/${data._id}' target="_blank" class="nav-link view_user"><i class="fa fa-eye"></i> View</a> <a href='#' class="nav-link delete_user"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.delete_user', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();
            $(".data-message").text(`Are you sure, you want to delete, ${capitalize(extract_td.raw.name)}?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                user("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Membership successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        $('#user tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Provincial:</td>' +
                '<td>' +
                d.raw.location.provincial.name +
                '</td>' +
                '</tr>' +
                '<tr>' +
                '<td>District:</td>' +
                '<td>'+d.raw.location.district.name+'</td>' +
                '</tr>' +
                '<tr>' +
                '<td>Constituency:</td>' +
                '<td>'+d.raw.location.constituency.name+'</td>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            table.destroy();
            filter = {};
        }

    }, []);

    const reloadTable = () => {
        $('#user').DataTable().ajax.reload(null, false);
        setReset(new Date().getTime());
    };

    const onAreaSelected = (data) => {
        const id = data?._id || null;
        const name = data?.name || "All Provinces";

        filter = id ? { "location.provincial": `ObjectId(${id})` } : {};

        $("#provincial-name").text(name);
        setProvincialSelected(id);

        $("#district-name").text("District");
        setConstituencySelected(null);

        $("#constituency-name").text("Constituency");
        setConstituencySelected(null);

        $('#user').DataTable().ajax.reload();
    };

    const onDistrictSelected = (data) => {
        filter = {"location.district": `ObjectId(${data._id})`};

        $("#district-name").text(data.name);
        setDistrictSelected(data._id);

        $("#constituency-name").text("Constituency");
        setConstituencySelected(null);

        $('#user').DataTable().ajax.reload();
    }

    const onConstituencySelected = (data) => {
        filter = {"location.constituency": `ObjectId(${data._id})`};
        $("#constituency-name").text(data.name);
        setConstituencySelected(data._id);

        $('#user').DataTable().ajax.reload();
    }

    const initialize = () => {
        $('#province').select2({
            placeholder: 'Select Provinces',
            maximumSelectionLength: 1,
            multiple: true,
            width: '100%',
            data: province.map(p => ({ id: p._id, text: capitalize(p.name) }))
        });

        $('#constituency, #ward').select2({
            placeholder: 'Select...',
            maximumSelectionLength: 1,
            multiple: true,
            width: '100%'
        });

        // Province → Constituency
        $('#province').on('change', function () {
            const selectedProvinces = $(this).val() || [];
            const filteredConstituencies = constituencies.filter(c =>
                selectedProvinces.includes(c.administrative)
            );

            $('#constituency').empty().select2({
                placeholder: 'Select Constituencies',
                maximumSelectionLength: 1,
                multiple: true,
                width: '100%',
                data: filteredConstituencies.map(c => ({
                    id: c._id,
                    text: capitalize(c.name)
                }))
            }).val(null).trigger('change');
        });

        // Constituency → Ward
        $('#constituency').on('change', function () {
            const selectedConstituencies = $(this).val() || [];
            const filteredWards = wards.filter(w =>
                selectedConstituencies.includes(w.constituency)
            );

            $('#ward').empty().select2({
                placeholder: 'Select Wards',
                maximumSelectionLength: 1,
                multiple: true,
                width: '100%',
                data: filteredWards.map(w => ({
                    id: w._id,
                    text: capitalize(w.name)
                }))
            }).val(null).trigger('change');
        });
    }

    const handleShowModal = () => {
        setEditForm(false);
        $('#membership_form').parsley();

        let name = $("#name");
        let username = $("#username");

        name.prop('disabled', false);
        username.prop('disabled', false);

        $("#password").prop('required', true);
        initialize();
        $("#modalMembership").modal("show");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let name = $('#name').val();
        let username = $('#username').val();
        let dob = $('#dob').val();
        let mobile_number = $('#mobile-number').val();
        let id_number = $('#id-number').val();
        let gender = $('#gender').val();
        let password = $('#password').val();
        let constituency = $('#constituency').val();
        let ward = $('#ward').val();

        let data = {
            name,
            username,
            id_number,
            mobile_number,
            gender,
            dob,
            password,
            constituency: constituency[0],
            ward: ward[0]
        };

        if(editForm) {
            Object.assign(data, {id: editId});
            user("put", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    cogoToast.success("Account successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalMembership", "membership_form");
                    reloadTable();
                }
            });

            return false;
        }

        setStateReady(true);

        user("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Account successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalMembership", "membership_form");
                reloadTable();
            }
        });
    };

    const handleDateChange = (e) => {
        let value = e.target.value.replace(/\D/g, "");

        if (value.length <= 2) {
            value = value;
        } else if (value.length <= 4) {
            value = value.slice(0, 2) + "/" + value.slice(2);
        } else {
            value = value.slice(0, 2) + "/" + value.slice(2, 4) + "/" + value.slice(4, 8);
        }

        $("#dob").val(value);
    };

    const handlerIDChange = (e) => {
        let value = e.target.value.replace(/\D/g, "");

        if (value.length <= 6) {
            value = value;
        } else if (value.length <= 8) {
            value = value.slice(0, 6) + "/" + value.slice(6);
        } else {
            value = value.slice(0, 6) + "/" + value.slice(6, 8) + "/" + value.slice(8, 9);
        }

        $("#id-number").val(value);
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const handleStatusChange = (data) => {
        const status = $("#tx-status");
        const dt_membership = $('#user');
        if(data === "all") {
            status.text("Select Status");
            if (filter.hasOwnProperty("status")) {
                delete filter["status"];
                dt_membership.DataTable().ajax.reload();
            }
            return false;
        }

        filter = Object.assign(filter, {status: data});
        status.text(capitalize(data));
        dt_membership.DataTable().ajax.reload();
    }

    const handleQualificationSelect = (data) => {
        const qualificationLevel = $("#tx-qualification-level");
        const dt_membership = $('#user');
        if(data === "General") {
            qualificationLevel.text("Select Qualification Level");
            if (filter.hasOwnProperty("qualification.level")) {
                delete filter["qualification.level"];
                dt_membership.DataTable().ajax.reload();
            }
            return false;
        }

        filter = Object.assign(filter, {"qualification.level": data});
        qualificationLevel.text(data);
        dt_membership.DataTable().ajax.reload();
    }

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Membership</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Membership</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-user-plus"></i> Add New</button>
                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-primary btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="provincial-name">All Provinces</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    <a href="#" onClick={(e) => {e.preventDefault(); onAreaSelected(null)}} className="dropdown-item">All Provinces</a>
                                    {province?.map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onAreaSelected(item)}} className="dropdown-item text-capitalize">{item.name}</a>
                                        )
                                    })}
                                </div>
                            </span>

                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-info btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="district-name">District</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    {provincialSelected ? districts?.filter((item) => item.administrative === provincialSelected).map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onDistrictSelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>
                                        )
                                    }) : <span className="dropdown-item">Select Province First</span>}
                                </div>
                            </span>

                        <span className="dropdown">
                                <button className="btn btn-sm pd-x-15 btn-outline-secondary btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="constituency-name">Constituency</span></button>
                                <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>
                                    {districtSelected ? constituencies?.filter((item) => item.district === districtSelected).map((item, index) => {
                                        return(
                                            <a href="#" key={index} onClick={(e) => {e.preventDefault(); onConstituencySelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>
                                        )
                                    }) : <span className="dropdown-item">Select District First</span>}
                                </div>
                            </span>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-4">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Registered Users</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-users" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">-</h3>
                            </div>
                            <span id="total-gender" className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Registered Users Today</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="daily-active" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="date-current" className="tx-11 tx-color-02 mg-b-0 mg-t-5">-</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-4 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Registered Users Monthly</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="monthly-active" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="month-current" className="tx-11 tx-color-02 mg-b-0 mg-t-5">-</span>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Membership List</h6>
                                <div className="d-flex tx-18 align-items-center">
                                    <div className="dropdown mg-r-10">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-status">Select Status</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, 'all')}>All</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "pending")}>Pending</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "awaiting")}>Awaiting</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "approved")}>Approved</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "rejected")}>Rejection</a>
                                        </div>
                                    </div>

                                    <div className="dropdown">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-qualification-level">Select Qualification Level</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            {qualification.map((item, index) => (
                                                <a className="dropdown-item" href="javascript:void(0)" key={index} onClick={handleQualificationSelect.bind(null, item)}>{item}</a>
                                            ))}
                                        </div>
                                    </div>

                                    <a href="#" onClick={(e) => {
                                        e.preventDefault();
                                        reloadTable();
                                    }} className="link-03 lh-0 ml-2"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="user" className="table">
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Mobile Number</th>
                                        <th className="wd-15p">Gender</th>
                                        <th className="wd-15p">Status</th>
                                        <th className="wd-15p">Date Created</th>
                                        <th className="wd-15p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalMembership" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalMembership", "membership_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit Membership" : "Create Membership"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} user to have access to the app</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="membership_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                    <div id="nameWrapper" className="form-group parsley-input">
                                        <label>Full Name<span className="tx-danger">*</span></label>
                                        <input id="name" type="text" className="form-control"
                                               placeholder="Enter full name"
                                               autoComplete="none"
                                               data-parsley-pattern="^([A-Za-z]+(?:\s[A-Za-z]+){1,2})$"
                                               data-parsley-pattern-message="Full name must be 2 or 3 words only."
                                               required/>
                                    </div>

                                    <div id="usernameWrapper" className="form-group parsley-input">
                                        <div className="d-flex justify-content-between">
                                            <label>Username<span className="tx-danger">*</span></label>
                                            <a href="javascript:void(0)"
                                               onClick={() => $("#username").val(generateChar(7))}
                                               className="link-01">Generate</a>
                                        </div>
                                        <input id="username" type="text" className="form-control"
                                               placeholder="Enter username"
                                               autoComplete="none"
                                               data-parsley-pattern="^\S+$"
                                               data-parsley-pattern-message="Username must be a single word without spaces."
                                               data-parsley-class-handler="#usernameWrapper"
                                               required/>
                                    </div>

                                    <div id="dobWrapper" className="form-group parsley-input">
                                        <label>Date of Birth <span className="tx-danger">*</span></label>
                                        <input id="dob" type="text" className="form-control" placeholder="DD/MM/YYYY"
                                            autoComplete="off"
                                            maxLength={10}
                                            onChange={handleDateChange}
                                            data-parsley-pattern="^([0-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$"
                                            data-parsley-pattern-message="Date of Birth must be in DD/MM/YYYY format (e.g. 25/12/1995)."
                                            data-parsley-class-handler="#dobWrapper"
                                            required
                                        />
                                    </div>

                                    <div id="genderWrapper" className="form-group parsley-input">
                                        <label>Gender<span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="gender" required>
                                            <option value="" disabled selected>Select Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </select>
                                    </div>

                                    <div id="mobileWrapper" className="form-group parsley-input">
                                        <label>Mobile Number<span className="tx-danger">*</span></label>
                                        <input id="mobile-number" type="text" className="form-control"
                                               placeholder="Enter mobile number"
                                               autoComplete="none"
                                               data-parsley-class-handler="#mobileWrapper" required/>
                                    </div>

                                    <div id="nrcWrapper" className="form-group parsley-input">
                                        <label>NRC Number<span className="tx-danger">*</span></label>
                                        <input id="id-number" type="text" className="form-control"
                                               placeholder="Enter NRC Number"
                                               autoComplete="none"
                                               onChange={handlerIDChange}
                                               data-parsley-pattern="^\d{6}\/\d{2}\/\d{1}$"
                                               data-parsley-pattern-message="NRC must be in the format XXXXXX/XX/X"
                                               data-parsley-class-handler="#nrcWrapper"
                                               required
                                        />
                                    </div>

                                    <div id="provinceWrapper" className="form-group parsley-input">
                                        <label>Province</label>
                                        <select id="province"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#provinceWrapper"
                                                data-parsley-errors-container="#provinceWrapper"
                                                className="custom-select"
                                                required
                                        >
                                        </select>
                                    </div>

                                    <div id="constituencyWrapper" className="form-group parsley-input">
                                        <label>Constituency</label>
                                        <select id="constituency"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#constituencyWrapper"
                                                data-parsley-errors-container="#constituencyWrapper"
                                                className="custom-select"
                                                required
                                        ></select>
                                    </div>

                                    <div id="wardWrapper" className="form-group parsley-input">
                                        <label>Ward</label>
                                        <select id="ward"
                                                data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#wardWrapper"
                                                data-parsley-errors-container="#wardWrapper"
                                                className="custom-select"
                                        ></select>
                                    </div>

                                    <div id="passwordWrapper" className="form-group parsley-input">
                                        <div className="d-flex justify-content-between">
                                            <label>Password<span className="tx-danger">*</span></label>
                                            <a href="javascript:void(0)"
                                               onClick={() => $("#password").val(generateChar(7))}
                                               className="link-01">Generate</a>
                                        </div>
                                        <input id="password" type="text" className="form-control"
                                               placeholder="Enter new password"
                                               autoComplete="none"
                                               data-parsley-class-handler="#passwordWrapper"/>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-primary btn-block">Update Account</button> : <button className="btn btn-primary btn-block">Create Account</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation"
                     aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Membership;
